import { type ValueOf } from 'src/types';
import { type InitializeClientAction } from 'src/types/actions';

import { AppActions } from '../constants/App';
import { type BrowserSupportLevels, type OsNames, ClientInfoKeys } from '../constants/ClientInfo';
import { Map } from '../lib/ImmutableUtils';
import { createReducer } from '../lib/ReducerUtils';

const INITIAL_STATE = Map({
  [ClientInfoKeys.BROWSER_NAME]: '',
  [ClientInfoKeys.BROWSER_VERSION]: '',
  [ClientInfoKeys.OS_NAME]: '' as ValueOf<typeof OsNames>,
  [ClientInfoKeys.OS_VERSION]: '',
  [ClientInfoKeys.BROWSER_SUPPORT]: '' as keyof typeof BrowserSupportLevels, // BrowserSupportLevels.NONE||BASIC||FULL
  [ClientInfoKeys.IS_ELECTRON]: false,
});
export type ClientInfoState = typeof INITIAL_STATE;

// CLIENTINFO REDUCER
export default createReducer(INITIAL_STATE, {
  [AppActions.INITIALIZE_CLIENT]: onInitializeClient,
});

function onInitializeClient(
  _state: ClientInfoState,
  { payload }: InitializeClientAction,
): ClientInfoState {
  return Map({
    [ClientInfoKeys.BROWSER_NAME]: payload.ua.browser.name,
    [ClientInfoKeys.BROWSER_VERSION]: payload.ua.browser.version,
    [ClientInfoKeys.OS_NAME]: payload.ua.os.name,
    [ClientInfoKeys.OS_VERSION]: payload.ua.os.version,
    [ClientInfoKeys.BROWSER_SUPPORT]: payload.browserSupportLevel,
    [ClientInfoKeys.IS_ELECTRON]: payload.isElectron,
  });
}
